export default function Home() {
    return (
        <div className="home-page">
            <div className="text-area">
                <h1>Jason Jacobs</h1>
                <p>Developer, game designer, and founder of ColdFlare Studios. I build games, tools, and digital worlds with a focus on racing, neon cities, sci-fi stories, and long-term creative independence.</p>
            
                <h2>Welcome to ColdFlare Studios</h2>
                <p>ColdFlare Studios is my independent game studio where I’m building arcade racers, experimental web games, and the foundation for a larger connected game universe.</p>
            </div>
        </div>
    );
}

// export default function Home() {
//   return <h1>Home Page</h1>;
// }